import { Image } from '@cian/ui-kit/image';
import * as React from 'react';

import { Pin } from './Pin';
import * as styles from './styles.css';

interface IMapPreviewProps {
  onClick?(e: React.MouseEvent<HTMLDivElement>): void;

  link: string;
}

export function MapPreview({ link, onClick }: IMapPreviewProps) {
  return (
    <div className={styles['map']} onClick={onClick}>
      <div className={styles['img']}>
        <Image width="100%" height="100%" src={link} borderRadius="4px" objectFit="cover" alt="map" />
      </div>
      <div className={styles['pin']}>
        <Pin />
      </div>
    </div>
  );
}
